import React, { useContext, useEffect } from "react";

import { BlankImg, Icon, LogoutIcon, Purebrand } from "assets/images";
import "./Sidebar.css";
import Sideitems from "./Sideitems";
import AuthContext from "context/AuthContext";
import NotificationContext from "context/NotificationContext";
import { Alert, Dropdown, Toast, ToastContainer } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import "Pages/dashboard/host/Dashboard/hostdashboard.css";
import { useEffectOnce } from "hooks/useEffectOnce";
import DemoContext from "context/DemoContext";
import ProfileContext from "context/ProfileContext";
import PaymentContext from "context/PaymentContext";
import ImgComponent from "components/imgComponent";
import DataContext from "context/DataContext";
import { Steps, Tooltip } from "antd";
import {
  UserOutlined,
  IdcardOutlined,
  ShopOutlined,
  ShoppingOutlined,
  MessageOutlined,
  FileTextOutlined,
  BankOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { STORE_ONBOARDING_STEP_CONFIG, getCompletedStepHashes } from "utils/onboardingStepMapper";
import useCan from "hooks/useCan";
import { CAPABILITIES } from "utils/capabilities";
import { ROLES, getRoleByValue } from "utils/constants";

const Sidebaar = (props) => {
  const { can, isResolved: capabilitiesResolved } = useCan();
  const { user, logoutUser, userProfile, resendVerification, isEmailVerified, onboardingStepCompletion, setOnboardingStepCompletion,authTokens} =
    useContext(AuthContext);
  const { isCategoriesAdded } =
    useContext(DataContext);
  const { notification, newNotifications, getBellNotification } =
    useContext(NotificationContext);
  let { updateHostRequests, updateHalfProfile } = useContext(ProfileContext);
  const { storeDemoPendingView, userDemos } = useContext(DemoContext);
  const { payToHostlist, cardDetailsHost, userPaymentDetail } =
    useContext(PaymentContext);
  const accountStatus = userProfile?.store?.is_account_connected;

  /** Only used when dots-account is in completed steps: show completed in UI iff account is connected. */
  const getIsDotsAccountConnected = () => {
    if (userProfile?.store?.is_account_connected === true) return true;
    if (userProfile?.store?.is_account_connected === false) return false;
    try {
      const stored = JSON.parse(localStorage.getItem("userProfile") || "{}");
      return stored?.store?.is_account_connected === true;
    } catch {
      return false;
    }
  };

  const [errorMessage, setErrorMessage] = useState(
    "You are not verified. Please check your email to get verified."
  );
  const [loadingNotification, setLoadingNotification] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [show, setShow] = useState(false);
  const [type, setType] = useState("all");
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const [location, setLocation] = useState("welcome");
  const [bellColour, setBellColour] = useState(null);
  let pathLocation = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const { hasNoPhotoProducts, checkMediaStatus } = useContext(ProfileContext);

  const checkProfile = async () => {
    await userPaymentDetail();
  };

  useEffect(() => {
    checkProfile();
  }, []);

  useEffect(() => {
    if (user?.role === 3) {
      checkMediaStatus();
    }
  }, [authTokens, user]);

  const handleLogout = () => {
    const logout = logoutUser();
    logout
      .then(function (response) {
        if (response.status === 200) {
          console.log("logged out");
          // Relative so logout stays on the current origin (app.purebrand.io
          // or purebrand.io) instead of the REACT_APP_URL-baked host.
          window.location.href = "/login"
        }
      })
      .catch((err) => {
        console.log(err);
        localStorage.clear();
        // <Redirect to={"/"} />;
      });
  };

  const isValidUrl = (urlString) => {
    try {
      return Boolean(new URL(urlString));
    } catch (e) {
      return false;
    }
  };

  const handleDropNotification = (e) => {
    if (e === "Product Approved" && user?.role === ROLES.PUREBRAND_ADMIN.role) {
      navigate("/user/showrooms");
    } else if (e === "Product Review" && can(CAPABILITIES.HOSTS_VIEW)) {
      navigate("/user/host");
    } else if (e === "Demo Requested" && user?.role === ROLES.HOST.role) {
      navigate("/user/meetings");
    }
  };

  const getnotification = () => {
    return newNotifications.map((x, index) => {
      if (type === "unread") {
        if (!x.is_seen) {
          return (
            <Dropdown.Item
              key={index}
              onClick={() => handleDropNotification(x.title)}
            >
              <p key={index} className="notification-body-menu">
                {x.body}
              </p>
            </Dropdown.Item>
          );
        }
      } else if (type === "read") {
        if (x.is_seen) {
          return (
            <Dropdown.Item
              key={index}
              onClick={() => handleDropNotification(x.title)}
            >
              <p key={index} className="notification-body-menu">
                {x.body}
              </p>
            </Dropdown.Item>
          );
        }
      } else {
        return (
          <Dropdown.Item
            key={index}
            onClick={() => handleDropNotification(x.title)}
          >
            <p key={index} className="notification-body-menu">
              {x.body}
            </p>
          </Dropdown.Item>
        );
      }
      return <></>;
    });
  };
  const pic = userProfile?.profile_picture?.file
    ? userProfile.profile_picture.file
    : "";
  const profilepicURL = pic;

  const handleClickNotification = () => {
    setLoadingNotification(true);
    setBellColour(false);
    const res = getBellNotification("&limit=5");
    if (res) {
      setLoadingNotification(false);
    }
  };
  useEffectOnce(() => {
    setLocation(pathname.split("/").slice(-1)[0]);
  }, [pathname]);

  const onToggleClick = (e) => {
    setIsActive(!isActive);
  };
  const onNavBarLogoPressed = () => {
    if (location === "home") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      navigate("/user/welcome");
    }
  };

  useEffectOnce(() => {
    setShow(true);
    setBellColour(true);
    getBellNotification("&limit=5");
    if (user?.role === ROLES.HOST.role) {
      userDemos();
    }
  }, [notification]);

  // Store-side request-dot counters. Each fetch is gated on the capability its
  // endpoint requires, so a role never fires a call it is not allowed to make
  // (a 403 would log the user out). Runs once capabilities are confirmed.
  const [storeCountersLoaded, setStoreCountersLoaded] = useState(false);
  useEffect(() => {
    if (!capabilitiesResolved || storeCountersLoaded) {
      return;
    }
    setStoreCountersLoaded(true);
    if (can(CAPABILITIES.MEETINGS_VIEW)) {
      storeDemoPendingView();
    }
    if (can(CAPABILITIES.HOSTS_VIEW)) {
      updateHostRequests(`?order=true&active=false`);
    }
    if (can(CAPABILITIES.ACCOUNTING_VIEW)) {
      payToHostlist("?order=true");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capabilitiesResolved]);

  // Define steps based on user role
  const getStepItems = () => {
    if (user?.role === 2) {
      const storeStepMeta = {
        "basic-info": {
          estTime: "2 min",
          tooltip: "Basic Information on store admin user such as mobile number",
        },
        "profile-info": {
          estTime: "2 min",
          tooltip: "Upload a profile photo for store admin user.",
        },
        "store-details": {
          estTime: "5 min",
          tooltip: "Provide all the store commission details such as video meeting commission, sales commission, discount etc. and the method of payment",
        },
        "dots-account": {
          estTime: "10 min",
          tooltip: "Connect your payout account.",
        },
        "shopify-details": {
          estTime: "2 min",
          tooltip: "Provide store logo, sample product video to upload on the site and time duration for shipping the product.",
        },
        "communications": {
          estTime: "5 min",
          tooltip: "Set up your communications flow templates and preferences.",
        },
        "agreement": {
          estTime: "10 min",
          tooltip: "Review and accept terms.",
        },
        
      };

      const iconMap = {
        "basic-info": <UserOutlined />,
        "profile-info": <IdcardOutlined />,
        "store-details": <ShopOutlined />,
        "dots-account": <BankOutlined />,
        "shopify-details": <ShoppingOutlined />,
        "communications": <MessageOutlined />,
        "agreement": <FileTextOutlined />,
      };

      return STORE_ONBOARDING_STEP_CONFIG.map((step) => ({
        title: step.label,
        hash: step.hash,
        icon: iconMap[step.hash],
        link:
          step.hash === "dots-account"
            ? "/user/settings?page=adminDots&fromOnboarding=true"
            : step.hash === "communications"
            ? "/user/flow?fromOnboarding=true"
            : undefined,
        estTime: storeStepMeta[step.hash]?.estTime,
        tooltip: storeStepMeta[step.hash]?.tooltip,
      }));
    } 
  };

  const stepItems = getStepItems() || [];
  const activeStep = stepItems[currentStep];

  const getStepIndexFromHash = (hashValue) => {
    if (!hashValue) {
      return -1;
    }
    return stepItems.findIndex((item) => `#${item.hash}` === hashValue);
  };

  const getStepIndexFromRoute = () => {
    if (!pathname) {
      return -1;
    }
    const currentRoute = `${pathname}${search || ""}`;
    return stepItems.findIndex((item) => item.link === currentRoute);
  };

  const getFirstIncompleteStepIndex = () => {
    const firstIncompleteIndex = stepItems.findIndex(
      (item) => onboardingStepCompletion?.[item.hash] !== true
    );
    return firstIncompleteIndex >= 0 ? firstIncompleteIndex : 0;
  };

  useEffect(() => {
    const routeIndex = getStepIndexFromRoute();
    if (routeIndex >= 0) {
      setCurrentStep(routeIndex);
      return;
    }
    const hashIndex = getStepIndexFromHash(hash);
    if (hashIndex >= 0) {
      setCurrentStep(hashIndex);
      return;
    }
    setCurrentStep(getFirstIncompleteStepIndex());
  }, [hash, pathname, search, stepItems, onboardingStepCompletion]);

  const handleStepperStepClick = async (step) => {
    const selectedStep = stepItems[step];
    if (!selectedStep) {
      return;
    }
    setCurrentStep(step);

    if (selectedStep?.link) {
      // Communications should remain active while visiting; do not auto-complete on navigation.
      if (selectedStep.hash !== "communications") {
        try {
          const completedHashes = getCompletedStepHashes(onboardingStepCompletion || {}, STORE_ONBOARDING_STEP_CONFIG);
          const steps = completedHashes.includes(selectedStep.hash) ? completedHashes : [...completedHashes, selectedStep.hash];
          await updateHalfProfile({ onboarding_completed_steps: steps });
          const next = { ...(onboardingStepCompletion || {}), [selectedStep.hash]: true };
          setOnboardingStepCompletion(next);
          localStorage.setItem("onboardingStepCompletion", JSON.stringify(next));
        } catch (e) {
          console.error("Half-profile update for redirect step failed", e);
        }
      }
      navigate(selectedStep.link);
      return;
    }

    const nextHash = selectedStep?.hash;
    if (nextHash) {
      const profilePath = user?.role === 2 ? "/user/completeprofile" : null;
      if (!profilePath) return;
      if (pathname === profilePath) {
        navigate({ pathname, search: search || "", hash: `#${nextHash}` });
      } else {
        navigate({ pathname: profilePath, hash: `#${nextHash}` });
      }
    }
  };

  if (user) {
    return (
      <React.Fragment>
        <div className="row main-row-wrapper">
          {pathLocation.pathname === "/user/set-password" ? null : (
            <>
              {" "}
              <div
                onClick={() => setIsActive(!isActive)}
                className={`overlay ${isActive ? "isactive" : ""}`}
              ></div>
              <div
                className={`sidebar-wrapper nav-container  ${
                  isActive ? "isactive" : ""
                }`}
              >
                <div className={`nav-toggle `} onClick={onToggleClick}></div>
                <nav className="sidebar open nav-items">
                  <header>
                    <div className="image-text">
                      <div className="sidebar-text logo-text">
                        <img
                          onClick={() => onNavBarLogoPressed()}
                          src={Purebrand}
                          className="logo-sidebar"
                          alt="logo"
                        />
                        {getRoleByValue(user?.role)?.portalLabel && (
                          <p className="user-status">
                            {getRoleByValue(user.role).portalLabel}
                          </p>
                        )}
                      </div>
                    </div>
                  </header>

                  <div className="menu-bar">
                    <div className="menu">
                      <ul className="menu-links">
                        <Sideitems setIsActive={setIsActive} />
                      </ul>
                    </div>

                    <div className="bottom-content">
                      <li className="nav-link">
                        <button onClick={handleLogout}>
                          <span className="nav-link">
                            {" "}
                            <img
                              src={LogoutIcon}
                              alt="home"
                              style={{ width: "32px", height: "32px" }}
                            />{" "}
                            Logout
                          </span>
                        </button>
                      </li>
                    </div>
                  </div>
                </nav>
              </div>
            </>
          )}

          <div className="right-content-wrapper">
            <div className="row user-wrapper">
              <div className="col d-flex top-user-wrap">
                <h3>
                  Hello {user?.firstName ? user.firstName : ""}{" "}
                  {user?.lastName ? user.lastName.charAt(0) : ""}.
                </h3>
              </div>
              {pathLocation.pathname === "/user/set-password" ? null : (
                <div className="col d-flex user-image-wrap">
                  <Dropdown
                    onClick={handleClickNotification}
                    className="bell-icon"
                  >
                    <Dropdown.Toggle
                      className=" d-flex"
                      variant="image"
                      id="dropdown-basic"
                    >
                      {bellColour === true ? (
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          id="_24x24_On_Light_Notification-Alert"
                          data-name="24x24/On Light/Notification-Alert"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            id="view-box"
                            width="24"
                            height="24"
                            fill="none"
                          />
                          <path
                            id="Shape"
                            d="M6,17v-.5H2.25A2.253,2.253,0,0,1,0,14.25v-.382a2.542,2.542,0,0,1,1.415-2.289A1.247,1.247,0,0,0,2.1,10.572l.446-4.91A6.227,6.227,0,0,1,10.618.286a5.477,5.477,0,0,0-.635,1.374A4.794,4.794,0,0,0,8.75,1.5,4.7,4.7,0,0,0,4.045,5.8L3.6,10.708A2.739,2.739,0,0,1,2.089,12.92a1.055,1.055,0,0,0-.589.949v.382A.751.751,0,0,0,2.25,15h13A.751.751,0,0,0,16,14.25v-.382a1.053,1.053,0,0,0-.586-.948A2.739,2.739,0,0,1,13.9,10.708l-.2-2.18a5.473,5.473,0,0,0,1.526.221l.166,1.822a1.26,1.26,0,0,0,.686,1.005,2.547,2.547,0,0,1,1.418,2.29v.382a2.252,2.252,0,0,1-2.25,2.25H11.5V17A2.75,2.75,0,0,1,6,17Zm1.5,0A1.25,1.25,0,0,0,10,17v-.5H7.5ZM15.047,6.744A3.486,3.486,0,0,1,13.5,6.28L13.456,5.8a4.7,4.7,0,0,0-1.648-3.185,3.5,3.5,0,0,1,.61-1.417A6.221,6.221,0,0,1,14.95,5.662l.1,1.081v0Z"
                            transform="translate(3.25 2.25)"
                            fill="#141124"
                          />
                          <path
                            id="Shape-2"
                            data-name="Shape"
                            d="M3.5,7A3.5,3.5,0,1,1,7,3.5,3.5,3.5,0,0,1,3.5,7Z"
                            transform="translate(15 2)"
                            fill="#ff6359"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          id="_24x24_On_Light_Notification"
                          data-name="24x24/On Light/Notification"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            id="view-box"
                            width="24"
                            height="24"
                            fill="none"
                          />
                          <path
                            id="Shape"
                            d="M6,17v-.5H2.25A2.253,2.253,0,0,1,0,14.25v-.382a2.542,2.542,0,0,1,1.415-2.289A1.248,1.248,0,0,0,2.1,10.572l.446-4.91a6.225,6.225,0,0,1,12.4,0l.446,4.91a1.26,1.26,0,0,0,.686,1.005,2.547,2.547,0,0,1,1.418,2.29v.382a2.252,2.252,0,0,1-2.25,2.25H11.5V17A2.75,2.75,0,0,1,6,17Zm1.5,0A1.25,1.25,0,0,0,10,17v-.5H7.5ZM4.045,5.8,3.6,10.708A2.738,2.738,0,0,1,2.089,12.92a1.055,1.055,0,0,0-.589.949v.382A.751.751,0,0,0,2.25,15h13A.751.751,0,0,0,16,14.25v-.382a1.054,1.054,0,0,0-.586-.948A2.739,2.739,0,0,1,13.9,10.708L13.456,5.8a4.725,4.725,0,0,0-9.411,0Z"
                            transform="translate(3.25 2.25)"
                            fill="#141124"
                          />
                        </svg>
                      )}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="notification-menu-box">
                      <div className="notification-menu-wrapper">
                        <nav className="nav">
                          <ul className="notification-nav">
                            <li
                              className={`nav-link ${
                                type === "all" ? "active-selection" : ""
                              }`}
                              onClick={() => setType("all")}
                            >
                              All
                            </li>
                            <li
                              className={`nav-link ${
                                type === "unread" ? "active-selection" : ""
                              }`}
                              onClick={() => setType("unread")}
                            >
                              Unread
                            </li>
                            <li
                              className={`nav-link ${
                                type === "read" ? "active-selection" : ""
                              }`}
                              onClick={() => setType("read")}
                            >
                              Read
                            </li>
                          </ul>
                        </nav>
                      </div>
                      {loadingNotification ? (
                        <Dropdown.Item>Loading list</Dropdown.Item>
                      ) : (
                        <></>
                      )}
                      {getnotification("all")}
                      <Dropdown.Item
                        onClick={() => navigate("/user/notifications")}
                        className="view-all-notification"
                      >
                        View all
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown>
                    <Dropdown.Toggle
                      className=" d-flex"
                      variant="text"
                      id="dropdown-basic"
                    >
                      <ImgComponent
                        src={
                          isValidUrl(profilepicURL) ? profilepicURL : BlankImg
                        }
                        alt="profile"
                        className="photo-profile"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigate("/user/profile")}>
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => navigate("/user/change-password")}
                      >
                        Change Password
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleLogout}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
            {notification.title === "" ? (
              <></>
            ) : (
              <ToastContainer className="p-3" position="bottom-end">
                <Toast
                  onClose={() => setShow(false)}
                  show={show}
                  delay={10000}
                  autohide
                  animation
                  // style={{
                  //   position: "absolute",
                  //   top: 100,
                  //   right: 20,
                  //   minWidth: 200,
                  // }}
                >
                  <Toast.Header>
                    <img
                      src={Icon}
                      style={{ height: "20px", width: "20px" }}
                      className="rounded me-2"
                      alt=""
                    />
                    <strong className="me-auto">{notification.title}</strong>
                    <small className="text-muted">just now</small>
                  </Toast.Header>
                  <Toast.Body>{notification.body}</Toast.Body>
                </Toast>
              </ToastContainer>
            )}

            {
              // TODO: This might be needed in future if it is required to keep this condition in a toast at the top of the layout
            }

            {/* {dotsStatus !== DOTS_CONNECT_STATUS.COMPLETE_FLOW &&
              user?.role === 3 && (
                <div className="not-verified-wrapper">
                  <Alert className="d-flex" key={"danger"} variant={"danger"}>
                    <p>
                      You have not completed your Payment Flow.
                      <span
                        onClick={() => {
                          navigate("settings");
                        }}
                        className="clicker-paragraph"
                      >
                        Click here{" "}
                      </span>
                      to complete your payment onboarding flow.
                    </p>
                  </Alert>
                </div>
              )} */}

            {!isEmailVerified ? (
              <div className="not-verified-wrapper">
                <Alert className="d-flex" key={"danger"} variant={"danger"}>
                  <p>
                    {errorMessage}{" "}
                    <span
                      onClick={() => {
                        const response = resendVerification();
                        response.then(function (response) {
                          if (response.status === 200) {
                            setErrorMessage("Check your email.");
                          }
                        });
                      }}
                      className="clicker-paragraph"
                    >
                      {" "}
                      Click here{" "}
                    </span>
                    to get the email again.
                  </p>
                </Alert>
              </div>
            ) : (
              <></>
            )}

            {userProfile && userProfile?.number_is_verified === false ? (
              <div className="not-verified-wrapper">
                <Alert className="d-flex" key={"danger"} variant={"danger"}>
                  <p>
                    Your phone number is not currently subscribed for notifications.{" "}
                    <span
                      onClick={() => navigate("/user/profile")}
                      className="clicker-paragraph"
                    >
                      {" "}
                      Click here{" "}
                    </span>
                    to visit your profile and subscribe.
                  </p>
                </Alert>
              </div>
            ) : (
              <></>
            )}
            {!accountStatus && capabilitiesResolved && can(CAPABILITIES.PAYMENT_SETUP_MANAGE) ? (
              <div className="not-verified-wrapper">
                <Alert className="d-flex" key={"danger"} variant={"danger"}>
                  <p>
                    You have not connected your dots account. Visit the Payment Setup in settings page to set it up{" "}or {" "}
                    <span
                      onClick={() => {
                        navigate("/user/settings?page=adminDots");
                        
                      }}
                      className="clicker-paragraph"
                    >
                      {" "}
                      Click here{" "}
                    </span>
                  </p>
                </Alert>
              </div>
            ) : (
              <></>
            )}

            {!isCategoriesAdded ? (
              <div className="not-verified-wrapper">
                <Alert className="d-flex" key={"danger"} variant={"danger"}>
                  <p>
                    You have a new product in your Purebrand account that needs to be assigned to a category. {" "}
                    <span
                      onClick={() => {
                        navigate("/user/productsList")
                      }}
                      className="clicker-paragraph"
                    >
                      {" "}
                      Click here{" "}
                    </span>
                    to assign.
                  </p>
                </Alert>
              </div>
            ) : (
              <></>
            )}
            {hasNoPhotoProducts && user?.role === 3 ? (
              <div className="not-verified-wrapper">
                <Alert className="d-flex" key={"danger"} variant={"danger"}>
                  <p>
                    You have products without photos. Please upload product images.{" "}
                    <span
                      onClick={() => navigate("/user/showrooms")}
                      className="clicker-paragraph"
                    >
                      Click here
                    </span>{" "}
                    to upload.
                  </p>
                </Alert>
              </div>
            ) : null}
            {(() => {
              const dotsInCompletedSteps = onboardingStepCompletion?.["dots-account"] === true;
              const dotsConnected = getIsDotsAccountConnected();
              const showStepper =
                user?.role === 2
                  ? !userProfile?.complete_profile || !dotsConnected
                  : !userProfile?.complete_profile;
              return showStepper ? (
              <div className="not-verified-wrapper">
              <div className="stepper-scroll-wrapper">
       <Steps
         className="stepper-bar"
         responsive
         size="small"
         current={currentStep}
         onChange={async (step) => { await handleStepperStepClick(step); }}
         items={stepItems.map((item, index) => {
           const stepInCompletedSteps = onboardingStepCompletion?.[item.hash] === true;
           const isDotsStep = item.hash === "dots-account";
           const isDotsAccountConnected = isDotsStep ? getIsDotsAccountConnected() : true;
           const isCompleted =
             isDotsStep
               ? stepInCompletedSteps && isDotsAccountConnected
               : stepInCompletedSteps;
           const isDotsPending = isDotsStep && stepInCompletedSteps && !isDotsAccountConnected;
           const estTimeText = item.estTime || "5 min";
           
           // Check if this is the agreement step and if previous steps are incomplete
           const isAgreementStep = item.hash === "agreement";
           const agreementComplete = onboardingStepCompletion?.["agreement"] === true;
           const hasPreviousIncompleteSteps = stepItems.slice(0, index).some((prevItem) => {
             const prevStepInCompletedSteps = onboardingStepCompletion?.[prevItem.hash] === true;
             const prevIsDotsStep = prevItem.hash === "dots-account";
             const prevIsDotsAccountConnected = prevIsDotsStep ? getIsDotsAccountConnected() : true;
             const prevIsCompleted = prevIsDotsStep
               ? prevStepInCompletedSteps && prevIsDotsAccountConnected
               : prevStepInCompletedSteps;
             return !prevIsCompleted;
           });
           
           // Determine the tooltip to show
           const tooltipContent = !agreementComplete && !isAgreementStep
             ? "Complete the agreement first"
             : isAgreementStep && hasPreviousIncompleteSteps && !isCompleted
             ? "Complete all previous steps to access this step"
             : item.tooltip;
           
           // Agreement is first: disable non-agreement steps until agreement is complete
           const isStepDisabled = isAgreementStep
             ? (hasPreviousIncompleteSteps && !isCompleted)
             : !agreementComplete;
           
           const handleTitleClick = (e) => {
             e.stopPropagation();
             if (isStepDisabled) return;
             handleStepperStepClick(index);
           };
           
           // Allow click on completed steps (view/edit); only agreement with incomplete previous is not clickable
           const cursorStyle = isStepDisabled ? "not-allowed" : "pointer";
           
           return {
             title: (
               <div
                 className="stepper-item-title"
                 style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: cursorStyle }}
                 onClick={isStepDisabled ? undefined : handleTitleClick}
                 onKeyDown={isStepDisabled ? undefined : (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleTitleClick(e); } }}
                 role={isStepDisabled ? undefined : "button"}
                 tabIndex={isStepDisabled ? undefined : 0}
               >
                 <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                   <span>{item.title}</span>
                   {tooltipContent ? (
                     <Tooltip title={tooltipContent} placement="top">
                       <InfoCircleOutlined style={{ cursor: "help", fontSize: "14px" }} />
                     </Tooltip>
                   ) : null}
                 </span>
                 <span className="time-estimate-badge">
                    &lt;{estTimeText}
                  </span>
               </div>
             ),
             icon: isCompleted ? (
               <CheckCircleOutlined style={{ color: "#52c41a", fontSize: "24px" }} />
             ) : isDotsPending ? (
               <ClockCircleOutlined style={{ color: "#faad14", fontSize: "24px" }} />
             ) : (
               item.icon
             ),
             status: isCompleted ? "finish" : index === currentStep ? "process" : "wait",
             disabled: isStepDisabled,
           };
         })}
       />
              </div>
      </div>
              ) : null;
            })()}
            <Outlet />
            {/* {props.children} */}
          </div>
        </div>
      </React.Fragment>
    );
  }
};

export default Sidebaar;
